import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import numeral from "numeral";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const RepeatOrderSummary = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
            process.env.REACT_APP_API_URL+'repeat_order_summary_report',  {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        })
		setPosts(result.data.data);
		setDataLoaded(true);
    }

	const data = async () => {
		// const res = await axios.get(
			//"https://www.breakingbadapi.com/api/characters"
		// 	"http://localhost/jcphq_new/public/repeat_order_summary_report?date_from=2015/01/01/&date_to=2016/12/01/&jc_user_id_no=DAVAOHQ"
		// );
		// process.env.REACT_APP_API_URL+'repeat_order_summary_report', {
        //     params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/01/01/',   
        //         jc_user_id_no: 'DAVAOHQ',  
        //     }
        // })	

		//console.log(res.data);
		//console.log(res.data.data);
	    // setPosts(res.data.data);
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "itemid",
			label: "Item ID",
		},
		{
			name: "qty",
			label: "Quantity",
			options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "invdetails",
			label: "Item Details",
		},
		{
			name: "itemprice",
			label: "Item Price",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
							// <div>{numeral(value).format('0,0.00')}</div>
					);
				}
			}
		},
		{
			name: "itempriceDP",
			label: "Item Price DP",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
							// <div>{numeral(value).format('0,0.00')}</div>
					);
				}
			}
		},
		{
			name: "itempriceDPB1T1",
			label: "Item Price DPB1T1",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
							// <div>{numeral(value).format('0,0.00')}</div>
					);
				}
			}
		},
		{
			name: "rowtotalrebates",
			label: "Row Total Rebates",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
							// <div>{numeral(value).format('0,0.00')}</div>
					);
				}
			}
		}
		// {
		// 	name: "pricecat",
		// 	label: "pricecat"

		// },
		// {
		// 	name: "pricecatDP",
		// 	label: "pricecatDP"
		// },
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: true,  //add this
		print: true,
		viewColumns:false, //add this 
		downloadOptions: {
			filename : 'RepeatOrderSummary.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Repeat Order Summary Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						{/* <Grid item xs={2}>
							<Input  style ={{marginTop: "24px"}}  placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={1} xl={1}> 
							<Button  style ={{marginTop: "23px"}}  variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid> 
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style={{color:"#339933"}}>
								Repeat Order Summary Report
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default RepeatOrderSummary;
